// extracted by mini-css-extract-plugin
export default {"wrapper":"WidgetFooter_wrapper__TToZy"};